module.exports = __webpack_public_path__ + "img/theater4.6131aeb6.jpg";